class ApiRfps {
    constructor(Restangular, ApiBaseResponseService) {
        return {
            /**
             * Get all/active rfps
             * @return {Object}
             */
            getRfps(rfpsFilter) {
                return Restangular
                    .all('requestForProposals')
                    .all('filter')
                    .post(rfpsFilter)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            /**
             * Get constants
             */
            getConstants() {
                return Restangular
                    .one('requestForProposals')
                    .one('constants')
                    .get()
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            }
        };
    }
}

ApiRfps.inject = ['Restangular', 'ApiBaseResponseService'];

export default ApiRfps;



/** WEBPACK FOOTER **
 ** ./src/app/services/apiRfps.js
 **/